/**
 * File: scrollto.js
 *
 * Smooth scrolling links with a hash
 */

( function () {
	//get all # links in the document
	const links = document.querySelectorAll( 'a[href*="#"]' );

	//assign a click event to all the # links
	for ( let link = 0; link < links.length; link++ ) {
		links[ link ].addEventListener( 'click', scrollMe, false );
	}

	function scrollMe( e ) {
		e.preventDefault(); //needed in order for the scroll to work

		const hash = e.target.hash;

		//check if hash is not empty
		if ( hash ) {
			const yOffset = -92;
			const element = document.querySelector( hash );
			const y =
				element.getBoundingClientRect().top +
				window.pageYOffset +
				yOffset;

			window.scrollTo( { top: y, behavior: 'smooth' } );
		}
	}
} )();
